import { generateUUID, isProductionEnv } from '../helpers/general'
import { useStore } from '../store'
import { getAnalytics, logEvent, setAnalyticsCollectionEnabled } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
}

const urlParams = new URLSearchParams(window.location.search)

const sparxSessionId = urlParams.get("session_id") || generateUUID()
const firebaseApp = initializeApp(firebaseConfig)
const firebaseAnalytics = getAnalytics(firebaseApp)

// Enable analytics on prod only
setAnalyticsCollectionEnabled(firebaseAnalytics, isProductionEnv())

export function captureEvent(event, data = {}) {
  if (!event) {
    console.warn(`Capture event failed. Event is undefined or null.`)
    return
  }

  const store = useStore.getState()

  const payload = {
    ...(event.data ? event.data({ ...store, ...data }) : {}),
    ...{ sparx_session_id: sparxSessionId, is_engaged: store.engaged },
  }

  if (localStorage.getItem('analytics.debug')) {
    console.log(`Analytics debug${store.config.block_analytics ? ' [BLOCKED] ' : ''} :`, { eventName: event.name, data: payload})
  }

  if(store.config.block_analytics){
    console.warn(`Event ${event.name} is not sent. Analytics is blocked.`)
    return
  }

  if (isProductionEnv()) {
    logEvent(firebaseAnalytics, event.name, payload)
  }
}
